import { Flex } from 'components/shared/flex'
import { InputField, SelectField } from 'components/shared/input'
import { Form } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { HasAddress, PREFECTURE_SELECT_ITEM } from 'entities/address'
import { Button } from 'react-bootstrap'
import { findAddressByZip } from 'utils/util'
import { useContext } from 'react'
import { GlobalStateContext } from 'contexts/global_state_context'

type AddressFormViewProps<T extends HasAddress> = {
    form: Form<T>
    apiError: ApiError
    prefix?: string
}

export const AddressFormView = <T extends HasAddress>({ form, apiError, prefix}: AddressFormViewProps<T>): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const addressKey = prefix || 'address';

    return (
        <>
            <Flex alignItems="flex-end">
                <InputField onlyHankaku form={form} attr={[addressKey, 'zipCode']} apiError={apiError} label="郵便番号" placeholder="1001234" required />
                <Button
                    disabled={!form.object.address?.zipCode}
                    style={{ width: 150, marginBottom: 15 }}
                    onClick={async () => {
                        const addressData = addressKey === 'address' 
                            ? form.object.address 
                            : addressKey === 'webAddress' 
                                ? form.object.webAddress 
                                : addressKey === 'invoiceAddress' 
                                    ? form.object.invoiceAddress 
                                    : undefined;
                        
                        const zipCode = addressData?.zipCode;
                        
                        if (zipCode) {
                            globalState.setLoading(true)
                            const address = await findAddressByZip(zipCode)
                            globalState.setLoading(false)
                            if (!address) {
                                globalState.setNotificationMessage({ body: 'この郵便番号の住所はありませんでした', colorType: 'warning' })
                            }
                            
                            form.update((f) => {
                                if (addressKey === 'address') {
                                    if (!f.address) f.address = { zipCode };
                                    f.address.prefecture = address?.prefecture;
                                    f.address.city = address?.city;
                                    f.address.line = address?.street;
                                } else if (addressKey === 'webAddress') {
                                    if (!f.webAddress) f.webAddress = { zipCode };
                                    f.webAddress.prefecture = address?.prefecture;
                                    f.webAddress.city = address?.city;
                                    f.webAddress.line = address?.street;
                                } else if (addressKey === 'invoiceAddress') {
                                    if (!f.invoiceAddress) f.invoiceAddress = { zipCode };
                                    f.invoiceAddress.prefecture = address?.prefecture;
                                    f.invoiceAddress.city = address?.city;
                                    f.invoiceAddress.line = address?.street;
                                }
                            })
                        }
                    }}
                >
                    住所検索
                </Button>
            </Flex>
            <Flex>
                <SelectField
                    form={form}
                    attr={[addressKey, 'prefecture']}
                    apiError={apiError}
                    selectItems={PREFECTURE_SELECT_ITEM}
                    includeBlank
                    label="都道府県"
                    required
                />
                <InputField form={form} attr={[addressKey, 'city']} apiError={apiError} label="市区町村" required />
            </Flex>
            <Flex>
                <InputField form={form} attr={[addressKey, 'line']} apiError={apiError} label="町名・番地" required />
            </Flex>
            <Flex>
                <InputField form={form} attr={[addressKey, 'building']} apiError={apiError} label="建物等" />
            </Flex>
        </>
    )
}
